module.exports = __webpack_public_path__ + "static/media/sitelogo.1ef49485.png";